/**
 * HTTP service for the cross-project read models (PX-W6.3, TASK-EDD04F2F).
 *
 * Two routes, both reads, both self-scoped: "my work" is the caller's, "my
 * client" is the client they are durably bound to. A firm-side (or
 * client-unbound) caller on my-client receives the typed 403
 * `project.client.landing.side` — the slice lands that in `clientBlocked`
 * (AC-6), never as an error toast and never as a client chooser.
 */

import { apiClient } from '@/services'
import type { MyClientLanding, MyWorkRow } from '../types'

export interface MyWorkQuery {
  /** Narrow to one project (slug). */
  projectId?: string
  limit?: number
  offset?: number
}

export const crossProjectReadService = {
  /** The caller's work across every project they are staffed on. */
  async myWork(orgId: string, query: MyWorkQuery = {}): Promise<MyWorkRow[]> {
    const qs = new URLSearchParams()
    if (query.projectId) qs.set('projectId', query.projectId)
    if (query.limit !== undefined) qs.set('limit', String(query.limit))
    if (query.offset !== undefined) qs.set('offset', String(query.offset))
    const search = qs.toString()
    return apiClient.get<MyWorkRow[]>(`/${orgId}/my-work${search ? `?${search}` : ''}`)
  },

  /** The projects of the client the caller is bound to. */
  async myClientProjects(orgId: string): Promise<MyClientLanding> {
    return apiClient.get<MyClientLanding>(`/${orgId}/my-client-projects`)
  }
}
